import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const alertTypes = {
  info: 'hicon-info',
  success: 'hicon-check-circle',
  error: 'hicon-remove-circle',
  warning: 'hicon-warning',
};

const dismissCloseButton = (
  <div className="d-flex align-items-center text-blue">
    <span>dismiss</span>
    <i className="hicon-close" style={{ fontSize: 24 }} />
  </div>
);

class AlertBlock extends Component {
  static propTypes = {
    type: PropTypes.oneOf(Object.keys(alertTypes)),
    className: PropTypes.string,
    iconContainerClass: PropTypes.string,
    simplified: PropTypes.bool,
    iconClass: PropTypes.string,
    hasCloseButton: PropTypes.bool,
    useDismissAsClose: PropTypes.bool,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
    ]).isRequired,
    onClose: PropTypes.func,
  };
  static defaultProps = {
    type: 'info',
    hasCloseButton: false,
    simplified: false,
    useDismissAsClose: false,
  };
  state = { opened: true };
  handleOnClose = () => {
    this.setState({ opened: false });
    if (this.props.onClose) this.props.onClose();
  }
  render() {
    const {
      type, className, iconClass,
      hasCloseButton, children, simplified,
      useDismissAsClose,
      iconContainerClass,
    } = this.props;
    const { opened } = this.state;
    const iconClassDisplay = iconClass || alertTypes[type];
    if (!opened) return null;
    return (
      <div className={cx('alert', type, className)} style={{ minHeight: simplified ? 40 : 50 }}>
        <div className="container align-items-center d-flex flex-grow">
          {(iconClass || iconClassDisplay) &&
          <div className={cx('alert-icon', iconContainerClass)}>
            <i
              className={iconClassDisplay}
              style={{ ...(simplified && { fontSize: 16, width: 'inherit', height: 'inherit' }) }}
            />
          </div>}
          <div className={cx('alert-body', { 'p-a-0': simplified })}>
            {children}
          </div>
          <div className="alert-close">
            {hasCloseButton && !useDismissAsClose &&
              <button className="btn btn-xs close" type="button" onClick={this.handleOnClose}><i className="hicon-cross" /></button>
            }
            {useDismissAsClose && !hasCloseButton &&
              <div
                className="cursor-pointer"
                onClick={this.handleOnClose}
              >
                {dismissCloseButton}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default AlertBlock;
